import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import "vue-search-select/dist/VueSearchSelect.css";

import "../src/design/app.scss";
import store from "@/state/store";
import App from "./App.vue";
import i18n from "./i18n";
import { configureFakeBackend } from "./helpers/fake-backend";
import tinymce from "vue-tinymce-editor";
import Notifications from "vue-notification";

import axios from "axios";
const userDetails = JSON.parse(window.localStorage.getItem("authUser"));

if (userDetails) {
  const token = JSON.parse(window.localStorage.getItem("authUser")).token;
  // axios.defaults.baseURL = "http://127.0.0.1:8000/api/";
  axios.defaults.baseURL = "https://api.dreamlanguagesug.com/api/";
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
} else {
  // axios.defaults.baseURL = "http://127.0.0.1:8000/api/";
  axios.defaults.baseURL = "https://api.dreamlanguagesug.com/api/";
  axios.defaults.headers.common["Authorization"] = `Bearer `;
}

configureFakeBackend();
Vue.component("tinymce", tinymce);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.component("apexchart", VueApexCharts);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
